import React, { useRef, useEffect } from "react";
import { Form, Button } from "react-bootstrap";

// Accept onResendOtp prop
const OtpInput = ({ otp, setOtp, onResendOtp }) => {
  const otpRefs = useRef([]);
  const otpKeys = [0, 1, 2, 3, 4, 5];

  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    // Allow only digits
    if (!/^\d*$/.test(value)) return; // Use \d* to allow clearing the input

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1); // Take only the last digit if multiple are entered/pasted quickly
    setOtp(newOtp);

    // Move focus to the next input if a digit was entered
    if (value && index < 5) {
      otpRefs.current[index + 1]?.focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace") {
       // If the current input is empty, move focus to the previous input and clear it
      if (!otp[index] && index > 0) {
        otpRefs.current[index - 1]?.focus();
         const newOtp = [...otp];
         newOtp[index - 1] = ""; // Clear previous input as well on backspace from empty field
         setOtp(newOtp);
      } else {
        // If the current input has a value, clear it
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
        // Keep focus here after clearing
      }
       e.preventDefault(); // Prevent default backspace behavior (like navigating back)
    } else if (e.key === "ArrowLeft" && index > 0) {
      otpRefs.current[index - 1]?.focus();
    } else if (e.key === "ArrowRight" && index < 5) {
      otpRefs.current[index + 1]?.focus();
    }
     // Handle digit input directly here as well if needed, though onChange covers it
     else if (/^\d$/.test(e.key) && index < 5) {
       // Optionally move focus immediately after keydown for faster input feel
       // setTimeout(() => otpRefs.current[index + 1]?.focus(), 0);
     }
  };

   const handleOtpPaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("Text").replace(/\D/g, "").slice(0, 6); // Remove non-digits
    if (!pastedData) return;

    const newOtp = Array(6).fill("");
    for (let i = 0; i < pastedData.length; i++) {
      newOtp[i] = pastedData[i];
    }
    setOtp(newOtp);

    // Focus the next empty input or the last input if full
    const nextFocusIndex = pastedData.length >= 6 ? 5 : pastedData.length;
     setTimeout(() => { // Use timeout to ensure state update and rendering before focus
        otpRefs.current[nextFocusIndex]?.focus();
     }, 0);
  };


  useEffect(() => {
    const firstInput = otpRefs.current[0];
    if (firstInput) {
      // Add paste event listener to the first input only
      firstInput.addEventListener("paste", handleOtpPaste);
    }
    return () => {
      if (firstInput) {
        firstInput.removeEventListener("paste", handleOtpPaste);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Rerun if the component instance changes, but not on otp state change

  // Focus the first input when the component mounts or becomes visible (e.g., when otpRequested becomes true)
  useEffect(() => {
     otpRefs.current[0]?.focus();
  }, []);


  return (
    <Form.Group controlId="formOtpInput" className="mt-4 mb-5">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "1rem",
        }}
      >
        <Form.Label style={{ fontWeight: "bold", fontSize: "0.95rem", marginBottom: 0 }}>
          Enter OTP
        </Form.Label>
        {/* Use the onResendOtp prop for the button */}
        {onResendOtp && (
          <Button
            variant="link"
            className="text-primary p-0"
            style={{ cursor: "pointer", fontSize: "0.85rem" }}
            onClick={onResendOtp} // Call the passed function
            type="button" // Prevent form submission if inside a form
          >
            Request new OTP
          </Button>
        )}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between", // Adjust spacing if needed
          gap: "10px", // Keep gap for spacing
          marginTop: "10px",
        }}
      >
        {otpKeys.map((key, index) => (
          <input
            key={`otp-input-${key}`}
            type="tel" // Use "tel" for numeric keyboard on mobile
            inputMode="numeric" // Hint for numeric keyboard
            autoComplete="one-time-code" // Help password managers/browsers autofill OTP
            maxLength="1"
            ref={(ref) => (otpRefs.current[index] = ref)}
            value={otp[index] || ""}
            onChange={(e) => handleOtpChange(e, index)}
            onKeyDown={(e) => handleOtpKeyDown(e, index)}
            style={{
              width: "40px", // Fixed width
              height: "50px",
              textAlign: "center",
              fontSize: "1.5rem",
              borderRadius: "8px",
              border: "1px solid #ccc",
              outline: "none",
              transition: "border-color 0.3s ease",
              // Add focus style
              // ':focus': { borderColor: '#0d6efd', boxShadow: '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' } // Pseudo-classes don't work in inline styles
            }}
            // Add required attribute if needed, though validation is manual
          />
        ))}
      </div>
    </Form.Group>
  );
};

export default OtpInput;
